import
  React, {
  useContext,
  useEffect,
  useState
} from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  HContainer,
  PillBar,
  Text,
  VContainer,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  DrupalProvider
} from 'providers';

import {
  AdvanceProvider
} from '../../providers';

import {
  AAPromptStates,
  AdvanceHistoryTab,
  AdvanceType,
  CacheKeys,
  CustomColors,
  ErrorKeys,
  Icons,
  OtpType,
  Pill,
  TransactionType,
  UserTypes
} from '../../../../constants';

import {
  ActionCardList,
  BackButton,
  ErrorCard,
  FullScreenCard,
  Hero,
  ModalCard,
  PrimaryButton,
  TabView
} from 'components';

import {
  HandleOtp,
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  getAuthToken,
  getStorageWithExpiry,
  isEqual,
  mapBalance
} from 'helpers';

import {
  AccountStatusCard,
  AdvanceHistoryCard
} from '../components';

import {
  AppContext
} from 'context';

export const AirtimeAdvanceLandingUI = props => {

  const location = useLocation();
  const history = useHistory();
  const { promptState, setPromptState } = useContext(AppContext);

  const [ state, setState ] = useState({
    item: location.state?.item,
    loading: true,
    error: null,
    userType: getStorageWithExpiry('msisdn', 'msisdnType', 'PREPAID'),
    showOtpModal: !getAuthToken(),
    showModal: false
  });

  const [ pills, setPills ] = useState({
    list: Pill,
    activePill: Pill[0].value,
    error: null
  });

  const [ balance, setBalance ] = useState({
    error: null,
    loading: false,
    data: null
  });

  const [ simSwapProcessed, setSimSwapProcessed ] = useState({
    simSwapProcessedRecently: false,
    data: null,
    error: null,
    loading: false,
    message: ''
  });

  const [ offers, setOffers ] = useState({
    error: null,
    loading: false,
    data: null,
    eligible: true,
    ineligibleMessage: '',
    messageDisplayed: false
  });

  const [ advanceHistory, setAdvanceHistory ] = useState({
    error: null,
    loading: false,
    data: null,
    numberOfCards: props.numberOfHistoryCards,
    selectedTab: AdvanceHistoryTab[0]
  });

  useEffect(() => {

    const init = async () => {

      if (state.showOtpModal) {
        return;
      }

      if (isEqual(state?.userType, UserTypes.Contract)) {

        setState(prevState => ({
          ...prevState,
          error: true,
          loading: false,
          offers: null
        }));

        return;
      }

      if (!state.item) {

        await getCachedData();
      }

      setState(prevState => ({
        ...prevState,
        loading: false
      }));

      if (!state.simSwapProcessed) {

        await getSimSwapEligibility();
      }

      await getBalances();

    };

    init();
  }, [ state?.showOtpModal ]);

  useEffect(() => {

    const initActivePill = async () => {

      if (state.showOtpModal) {
        return;
      }

      if (isEqual(pills.activePill, Pill[0].value)) {

        getAvailableOffers();
        return;
      }

      if (isEqual(pills.activePill, Pill[1].value)) {

        getAdvanceHistory();
        return;
      }
    };

    initActivePill();
  }, [ pills.activePill, state?.showOtpModal ]);

  const renderContractUserErrorCard = () => {

    return (

      <FullScreenCard
        title={'We\'re sorry'}
        message={'This service is currently unavailable to Contract customers.'}
        onClose={() => {

          setState(prevState => ({
            ...prevState,
            showModal: false
          }));

          history.goBack();

        }}
        pageName= {'cbu: connectu: airtime advance: eligibility check: contract'}
        tagViewData={{
          page_section: 'airtime advance',
          visitor_customer_segment: AirtimeAdvanceLandingUI.tagViewData.visitor_customer_segment,
          visitor_type: 'consumer',
          visitor_id_asset_active: AirtimeAdvanceLandingUI.tagViewData.visitor_id_asset_active
        }} />
    );
  };

  const renderSimSwapErrorCard = () => {

    return (

      <ErrorCard
        src={Icons.IconError}
        title={'Advances unavailable'}
        message={`${simSwapProcessed.message} \n\n Please try again later`}
          buttonText={'Back'}
          onClose={() => {

          setState(prevState => ({
            ...prevState,
            showModal: false
          }));

          history.goBack();

        }}
        pageName= {'cbu: connectu: airtime advance: sim swap processed check: simSwapProcessedRecently'}
        tagViewData={{
          page_section: 'airtime advance',
          visitor_customer_segment: AirtimeAdvanceLandingUI.tagViewData.visitor_customer_segment,
          visitor_type: 'consumer',
          visitor_id_asset_active: AirtimeAdvanceLandingUI.tagViewData.visitor_id_asset_active
        }}
      />
    );
  };

  const renderIneligibleErrorCard = () => {

    if (offers.messageDisplayed) {
      return;
    }

    return (

      <FullScreenCard
        title={'Please note:'}
        message={offers.ineligibleMessage}
        onClose={() => {

          if (promptState === AAPromptStates.Started) {

            setPromptState(AAPromptStates.Finished);
          }

          setOffers(prevState => ({
            ...prevState,
            eligible: true,
            messageDisplayed: true
          }));

        }}
        pageName= {'cbu: connectu: airtime advance: eligibility check: recharge'}
        tagViewData={{
          page_section: 'airtime advance',
          visitor_customer_segment: AirtimeAdvanceLandingUI.tagViewData.visitor_customer_segment,
          visitor_type: 'consumer',
          visitor_id_asset_active: AirtimeAdvanceLandingUI.tagViewData.visitor_id_asset_active
        }} />
    );
  };

  const requestOtp = async (response) => {

    if (!response?.result?.successful || !response?.ok || response?.result?.locked) {

      setState(prevState => ({
        ...prevState,
        errorMessage: response?.result?.message || state.errorMessage,
        showModal: true,
        loading: false
      }));

      return;
    }
  };

  const resendOtp = async (response) => {

    if (!response?.result?.successful || response?.result?.locked) {

      setState(prevState => ({
        ...prevState,
        errorMessage: response?.result?.message || state.errorMessage,
        showModal: true
      }));

      return;
    }

    window?.utag?.view(
      {
        page_name: 'cbu: connectu: airtime advance: resent otp',
        page_section: 'airtime advance',
        visitor_type: 'consumer',
        visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
        visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
      }
    );
  };

  const verifyOtp = async (response) => {

    if (!response?.ok || !response.result) {

      if (response?.code === 401 || response?.code === 403) {

        window?.utag?.view(
          {
            page_event: 'page_error',
            page_section: 'airtime advance',
            error_message: response?.error
          }
        );

        return;
      }

      setState(prevState => ({
        ...prevState,
        otpLoading: false,
        error: response.error,
        errorMessage: 'There was a problem directing you to airtime advance. Please try again later or call 082 135'
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      showOtpModal: false
    }));
  };

  const ErrorModalCard = () => {

    return (

      <ModalCard
        padding={'22px 34px 33px'}
        isSuccess={false}
        iconHeight={'80px'}
        iconWidth={'80px'}
        title={'Something went wrong.'}
        titleFontSize={'26px'}
        message={state.errorMessage}
        messageFontFamily={'Roboto'}
        messageWeight={'normal'}
        messageFontSize={'14px'}
        buttonText={'Okay'}
        onClose={() => {

          setState(prevState => ({
            ...prevState,
            showModal: false
          }));

          history.goBack();
        }}
        pageSection={'airtime advance'}
        pageName= {'cbu: connectu: airtime advance: purchase complete'}
        tagViewData={{
          ...AirtimeAdvanceLandingUI.tagViewData,
          journey_event: 'journey_end',
          journey_step: 'cbu: connectu: airtime advance: purchase complete',
          journey_type: 'just for you',
          sales_event: 'transaction_complete, airtimeadvance',
          transaction_id: 'order reference number'
        }} />
    );
  };

  const getBalances = async () => {

    setBalance(prevState => ({
      ...prevState,
      loading: true
    }));

    const response = await AdvanceProvider.getCachedItem(
      CacheKeys.AirtimeAdvanceBalances,
      null,
      AdvanceProvider.getBalances
    );

    if (!response?.ok) {

      setBalance(prevState => ({
        ...prevState,
        loading: false,
        error: response?.error
      }));

      return;
    }

    setBalance(prevState => ({
      ...prevState,
      loading: false,
      data: mapBalance(response.result)
    }));
  };

  const actionOnClick = (
    id,
    type
  ) => {
    history.push(`/advance/payment?advance_id=${id}&advance_type=${type}`);
  };

  const formatAvailableOffers = (unformattedOffers) => {

    const list = [];
    const subText =
      isEqual(unformattedOffers?.[0]?.type, AdvanceType.Data)
        ? 'Data bundles are available until midnight'
        : undefined;

    unformattedOffers?.forEach?.(offer => {
      list.push({
        text: offer?.displayValue,
        subText: subText,
        onClick: () => actionOnClick(offer?.id, unformattedOffers[0]?.type)
      });
    });

    return list;
  };

  const formatVoiceOffers = (unformattedOffers) => {

    const list = [];

    unformattedOffers?.forEach?.(offer => {
      list.push({
        text: offer?.displayValue?.replace(/\([^()]*\)/g, '') || offer?.displayValue,
        subText: offer?.displayValue?.match(/\(([^)]+)\)/)?.[1] || 'Any network',
        onClick: () => actionOnClick(offer?.id, offer?.type)
      });
    });

    return list;
  };

  const onPillClicked = (selectedPill) => {

    if (isEqual(selectedPill.value, Pill[0].value)) {

      AirtimeAdvanceLandingUI.tagViewData = {
        journey_step: 'cbu: connectu: airtime advance: dashboard: available',
        journey_type: 'airtime advance'
      };
    }

    if (isEqual(selectedPill.value, Pill[1].value)) {

      AirtimeAdvanceLandingUI.tagViewData = {
        journey_step: 'cbu: connectu: airtime advance: dashboard: your history: active',
        journey_type: 'just for you'
      };
    }

    window?.utag?.view(
      {
        page_event: 'view',
        page_name: AirtimeAdvanceLandingUI.pageName,
        ...AirtimeAdvanceLandingUI.tagViewData
      }
    );

    setPills(prevState => ({
      ...prevState,
      activePill: selectedPill.value
    }));
  };

  const getCachedData = async () => {

    const cachedItem = await DrupalProvider.getCachedItem(
      `${CacheKeys.Pillars}buy`,
      null,
      () => DrupalProvider.getPillarTiles('buy')
    );

    if (!cachedItem || !cachedItem?.ok || !cachedItem?.result) {

      setState(prevState => ({
        ...prevState,
        error: true,
        loading: false
      }));

      return;
    }

    const advanceItem =
      cachedItem?.result?.find(
        item => item?.title?.toLowerCase()?.includes('airtime') && item?.title?.toLowerCase()?.includes('advance')
      );

    setState(prevState => ({
      ...prevState,
      item: advanceItem,
      loading: false
    }));
  };

  const getAvailableOffers = async () => {

    setOffers(prevState => ({
      ...prevState,
      loading: true
    }));

    const response = await AdvanceProvider.getCachedItem(
      CacheKeys.AirtimeAdvanceOffers,
      null,
      AdvanceProvider.getAvailableOffers
    );

    if (!response?.ok) {

      if (response?.code === 400 || response?.code === 412) {
        setOffers(prevState => ({
          ...prevState,
          loading: false,
          eligible: false,
          ineligibleMessage: response.error?.response?.data?.result?.message || 'To continue using this service, please recharge with a minimum of R29 monthly for the next 3 months.\n\nNeed help? Call 082 135, FREE from a Vodacom phone.'
        }));
        return;
      }

      setOffers(prevState => ({
        ...prevState,
        loading: false,
        error: true
      }));

      return;
    }

    setOffers(prevState => ({
      ...prevState,
      loading: false,
      data: response?.result,
      eligible: true
    }));
  };

  const getSimSwapEligibility = async () => {

    setOffers(prevState => ({
      ...prevState,
      loading: true
    }));

    const response = await AdvanceProvider.getCachedItem(
      CacheKeys.AirtimeAdvanceEligibility,
      null,
      AdvanceProvider.getSimSwapEligibility
    );

    if (!response?.ok) {

      setSimSwapProcessed(prevState => ({
        ...prevState,
        loading: false,
        error: response?.error
      }));

      return;
    }

    setSimSwapProcessed(prevState => ({
      ...prevState,
      message: response?.result?.message,
      simSwapProcessedRecently: response?.result?.simSwapProcessedRecently
    }));
  };

  const getAdvanceHistory = async () => {

    setAdvanceHistory(prevState => ({
      ...prevState,
      loading: true
    }));

    const response = await AdvanceProvider.getCachedItem(CacheKeys.AirtimeAdvanceHistory, null, AdvanceProvider.getAdvanceHistory);

    if (!response?.ok) {

      setAdvanceHistory(prevState => ({
        ...prevState,
        loading: false,
        error: true
      }));
    }

    setAdvanceHistory(prevState => ({
      ...prevState,
      loading: false,
      data: response?.result,
      numberOfCards: props.numberOfHistoryCards
    }));
  };

  const buildHero = () => {

    return (

      <Hero
        background={`${Environment.current.drupalBaseUrl}${state.item?.image}`}
        useOverLay={true}
        subtitle={state.item.category}
        title={state.item?.title}
        caption={'Stay in contact today and pay the next time you recharge or purchase a direct bundle. '}
        clickOutText={'Find out more'}
        clickOutFontWeight={'inherit'}
        clickOutUnderline={true}
        onClick={() => {

          history.push({
            pathname: `/advance/${state.item?.id}`,
            state: {
              item: state.item,
              hideButton: true
            }
          });
        }} />
    );
  };

  const buildAccountStatus = () => {

    return (

      <HandleRender
        isLoading={balance.loading}
        isError={balance.error}
        error={{ type: ErrorKeys.Children }}
        loader={{ size: '100', margin: '16px' }} >

        <VContainer>
          <AccountStatusCard
            isError={balance.error}
            amountLeft={balance?.data?.availableAdvance}
            qualifyValue={balance?.data?.advanceLimit}
            margin={'0 0 32px'}/>
        </VContainer>
      </HandleRender>
    );
  };

  const buildPillbar = () => {

    return (

      <VFillContainer
        padding={'0 4px'} >
        <HContainer
          border={`1px solid ${CustomColors.Grey5}`}
          borderRadius={'4px'}
          overflow={'hidden'} >

          <PillBar
            defaultPill={pills.activePill}
            onPillClicked={onPillClicked}
            pills={pills.list}
            pillBorder={'none'}
            pillBorderRadius={'4px'}
            pillBarBackgroundColor={CustomColors.White}
            pillMargin={'0'}
            inActiveFontColor={CustomColors.Grey8}
            activeColor={CustomColors.Grey9}
            textPadding={'9px 0'}
            fontSize={'16px'}
            fontWeight={'bold'}
            fontFamily={'Roboto'} />
        </HContainer>

          {
            isEqual(pills.activePill, Pill[0].value)
              ? buildAvailableOffers()
              : isEqual(pills.activePill, Pill[1].value)
                ? buildHistory()
                : <></>
          }
      </VFillContainer>
    );
  };

  const buildAvailableOffers = () => {

    let noOffers = offers?.data?.dataBands?.length === 0
      && offers?.data?.airtimeBands?.length === 0
      && offers?.data?.voiceBands?.length === 0;

    return (

      <HandleRender
        isLoading={offers.loading}
        isError={offers.error || !offers.data || noOffers}
        error={{
          type: ErrorKeys.TextOnly,
          title: 'Unfortunately there are no available offers at the moment. Try again later.',
          pageName: AirtimeAdvanceLandingUI.pageName,
          tagViewData: {
            page_section: 'airtime advance'
          }
        }}
        loader={{ size: '100', margin: '16px' }} >

        <VContainer>

          { offers?.data?.dataBands?.length > 0 &&

            <ActionCardList
              title={'Choose data amount'}
              titleColor={CustomColors.Grey9}
              subtextFontColor={CustomColors.Grey9}
              cardPadding={'0 0 1px;'}
              items={formatAvailableOffers(offers?.data?.dataBands)}/>
          }

          { offers?.data?.airtimeBands?.length > 0 && promptState !== AAPromptStates.Started &&

            <ActionCardList
              title={'Choose airtime amount'}
              titleColor={CustomColors.Grey9}
              subtextFontColor={CustomColors.Grey9}
              cardPadding={'0 0 1px;'}
              items={formatAvailableOffers(offers?.data?.airtimeBands)}/>
          }

          { offers?.data?.voiceBands?.length > 0 && promptState !== AAPromptStates.Started &&

            <ActionCardList
              title={'Choose voice amount'}
              titleColor={CustomColors.Grey9}
              subtextFontColor={CustomColors.Grey9}
              cardPadding={'0 0 1px;'}
              items={formatVoiceOffers(offers?.data?.voiceBands)}/>
          }

        </VContainer>
      </HandleRender>
    );
  };

  const createHistoryTabList = () => {

    let componentList = [];

    let advanceHistoryData = {};
    advanceHistoryData[AdvanceHistoryTab[0].value] =
      advanceHistory?.data?.loans?.filter(
        loan => isEqual(loan?.transactionType, TransactionType.Advance)
      );

    advanceHistoryData[AdvanceHistoryTab[1].value] =
      advanceHistory?.data?.loans?.filter(
        loan => isEqual(loan?.transactionType, TransactionType.Recovery)
      );

    for (const [ historyType, historyData ] of Object.entries(advanceHistoryData)) {

      let list = [];

      // TODO: Refactor this to no longer use forEach
      historyData?.slice(0, advanceHistory.numberOfCards).forEach((advance, index) => {

        if (!advance || !Object.keys(advance)?.length) {
          return;
        }

        list.push(

          <AdvanceHistoryCard
            key={`advance-history-card-${index}`}
            accessFee={advance.band?.serviceFee?.displayValue}
            date={advance.date}
            description={advance.band?.displayValue}
            totalRepayment={advance.band?.totalRepaymentValue?.displayValue}/>
        );
      });

      if (historyData.length > advanceHistory.numberOfCards) {

        list.push(

          <VContainerVH
            key={'load-more-button'}>

            <PrimaryButton
              key={'load-more-button'}
              margin={'32px 0px 0px'}
              activeBackgroundColor={CustomColors.Grey9}
              activeBorderColor={CustomColors.Grey9}
              text={'Load More'}
              onClick={() => {

                setAdvanceHistory(prevState => ({
                  ...prevState,
                  numberOfCards: prevState.numberOfCards + props.numberOfHistoryCards
                }));
              }}/>
            </VContainerVH>
        );
      }

      if (!list.length) {

        const message =
          isEqual(historyType, AdvanceHistoryTab[0].value)
            ? 'You have not taken any Advances yet.'
            : 'You have not made any repayments.';

        list.push(

          <VContainerVH
            key={'no-content-message'}>

            <Text
              fontSize={'16px'}
              padding={'22px'}
              color={CustomColors.Grey9}
              textAlign={'center'}>

              {message}
            </Text>
          </VContainerVH>
        );
      }

      componentList.push({
        component: list,
        value: historyType
      });
    }

    return componentList;
  };

  const buildHistory = () => {

    return (

      <HandleRender
        isLoading={advanceHistory.loading}
        isError={advanceHistory.error}
        error={{
          type: ErrorKeys.TextOnly,
          title: 'Something’s wrong. Please refresh your page or come back later.',
          pageName: AirtimeAdvanceLandingUI.pageName,
          tagViewData: {
            page_section: 'airtime advance'
          }
        }}
        loader={{ size: '100', margin: '16px' }} >

        { advanceHistory.data &&

          <TabView
            margin={'10px 0'}
            width={'100%'}
            tabList={AdvanceHistoryTab}
            tabData={createHistoryTabList()}

            flex={'0 0 auto'}
            justifyContent={'center'}
            borderBottom={`solid 3px ${CustomColors.Grey3}`}
            borderBottomSize={'-3px'}
            tagViewData={AirtimeAdvanceLandingUI.tagViewData}
            defaultTab={advanceHistory.selectedTab}
            onTabClick={tab => {

              setAdvanceHistory(prevState => ({
                ...prevState,
                numberOfCards: props.numberOfHistoryCards,
                selectedTab: tab
              }));
            }}/>

        }

      </HandleRender>
    );
  };

  const AdvanceDashboard = () => {

    return (

      <>

        {
          state.item &&
          buildHero()
        }

        <BackButton
          margin={'16px 0 24px 16px'}
          onClick={() => {

            if (promptState === AAPromptStates.Started) {

              setPromptState(AAPromptStates.Finished);
            }

            history.goBack();
          }} />

        <VFillContainer
          padding={'0 16px 16px'} >

          {
            buildAccountStatus()
          }

          {
            pills.list &&
            buildPillbar()
          }
        </VFillContainer>
      </>
    );
  };

  const renderOtpWrapper = () => {

    return (

      <HandleOtp
        onRequestOtp={response => requestOtp(response)}
        onResendOtp={response => resendOtp(response)}
        onVerifyOtp={response => verifyOtp(response)}
        otpType={OtpType.Auth}
        onClose={() => {

          if (promptState === AAPromptStates.Started) {

            setPromptState(AAPromptStates.Finished);
          }

          history.goBack();
        }}
        renderModal={true}
        pageName={'cbu: connectu: airtime advance: enter otp'}
        tagViewData={{
          visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
          visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
          page_section: 'airtime advance',
          visitor_type: 'consumer'
        }}>

        <HandleRender
          isLoading={state.loading || offers.loading}
          isError={state.error}>

          {
            state.showModal

              ? <ErrorModalCard/>

              : <VFillContainer
                  backgroundColor={CustomColors.Grey2}>

                    {!offers.eligible && renderIneligibleErrorCard()}

                  <AdvanceDashboard/>
                </VFillContainer>
          }
        </HandleRender>

      </HandleOtp>
    );
  };

  return (

    <>
      {
        isEqual(state.userType, UserTypes.Contract)
          ? renderContractUserErrorCard()
          : isEqual(simSwapProcessed.simSwapProcessedRecently, true)
          ? renderSimSwapErrorCard()
          : renderOtpWrapper()
      }
    </>

  );
};

AirtimeAdvanceLandingUI.defaultProps = {
  numberOfHistoryCards: 3
};

AirtimeAdvanceLandingUI.pageName = 'cbu: connectu: airtime advance: dashboard';

AirtimeAdvanceLandingUI.tagViewData = {
  journey_event: 'journey_start,journey_end',
  journey_step: 'cbu: connectu: airtime advance: dashboard: available',
  journey_name: 'cbu: connectu: airtime advance: dashboard',
  journey_type: 'airtime advance',
  page_section: 'airtime advance',
  visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
  visitor_type: 'consumer',
  visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
};

export const AirtimeAdvanceLanding = withScreenViewTagging(AirtimeAdvanceLandingUI);
